
import { User } from '@app/data/user';

export class DigitalOrderSheet {
  _id: string;
  user: User;
  source: string;
  percentage_off: number;
  selection: any[];
  listings: any[];
  display_msrp: boolean;
  thank_you_message: string;
  default_tax: number;
  // default_shipping_rate: number;
}